import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Rest from "../../services/Rest";

const inicialState = {
    usuario: {
        id: "",
        usuario: "",
        correo: "",
        nombre: "",
        apellidos: "",
        ip: "",
        habilitar: 0,
        precio: 0,
        bloqueo: 0,
        uBloqueado: false,
        ipHabilitada: false,
        vHabilitada: 0,
        contrasena: ""
    },
    stateUsuariosLS: [],
    error: false,
    message: "",
    success: false,
    successe: false
}

class Formusers extends Component {

    constructor(props) {
        super(props);
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    state = { ...inicialState };


    componentDidMount() {
        //datos del usuario a editar
        this.obtenerUsuario(this.props.id);
    }

    handleSubmit = e => {
        e.preventDefault();
        //extraer los valores de la nueva campaña
        const { correo, usuario, nombre, apellidos, ip, habilitar, precio, bloqueo } = this.state.usuario;

        if (correo === ""
            || usuario === ""
            || nombre === ""
            || apellidos === ""
            || habilitar === ""
            || precio === ""
            || bloqueo === "") {
            this.setState({
                error: true,
                message: "Todos los campos son requeridos"
            });
            return;
        }

        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(correo) === false) {
            this.setState({
                error: true,
                message: "Ingrese un correo electrónico válido."
            })
            return;
        }

        // if (/^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/.test(ip) === false) {
        //     this.setState({
        //         error: true,
        //         message: "Ingrese una IP válida."
        //     })
        //     return;
        // }


        if (this.props.id)
            this.actualizarUsuario();
        else
            this.guardarNvoUsuario();
    }


    actualizarUsuario() {
        this.refs.btnGuardar.setAttribute('disabled', 'disabled');
        this.refs.btnGuardar.innerHTML = "Guardando...";
        this.setState({
            error: false,
            message: ""
        })
        this.Rest.post(this.state.usuario, "usuarios/actualizar", "usuario", this.datauser)
            .then(response => {
                if (response.status === 200) {
                    //localStorage.setItem("datauser", JSON.stringify(this.state.usuario));
                    this.setState({
                        successe: true
                    }, () => {
                        this.props.history.push("/lista-de-usuarios");
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            message: response.message
                        })
                        this.refs.btnGuardar.removeAttribute('disabled');
                        this.refs.btnGuardar.innerHTML = "Guardar";
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    message: "Error de respuesta del servidor"
                })
                this.refs.btnGuardar.removeAttribute('disabled');
                this.refs.btnGuardar.innerHTML = "Guardar";
            })
    }

    /**
     * primer parametro es la data del state
     * segundo parametro es la url del endpoint
     * tercer parametro es la key para obtener en el rest p.ej. $data['usuario'] = {uid:1,...}
     */
    guardarNvoUsuario() {

        this.refs.btnGuardar.setAttribute('disabled', 'disabled');
        this.refs.btnGuardar.innerHTML = "Guardando...";

        this.setState({
            error: false,
            message: ""
        })

        this.Rest.post(this.state.usuario, "usuarios", "usuario", this.datauser)
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        success: true
                    }, () => {
                        this.props.history.push("/lista-de-usuarios")
                    })
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            message: response.message
                        })
                        this.refs.btnGuardar.removeAttribute('disabled');
                        this.refs.btnGuardar.innerHTML = "Guardar";
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    message: "Error de respuesta del servidor"
                })
                this.refs.btnGuardar.removeAttribute('disabled');
                this.refs.btnGuardar.innerHTML = "Guardar";
            })
    }

    obtenerUsuario(id) {
        if (id) {
            this.Rest.get("usuarios/" + id, this.datauser)
                .then(usuario => {

                    if (usuario.status === 200) {
                        if (usuario.data.uid !== "") {
                            let u = usuario.data;
                            this.setState({
                                usuario: {
                                    uid: u.uid,
                                    usuario: u.usuario,
                                    correo: u.correo,
                                    nombre: u.nombre,
                                    apellidos: u.apellidos,
                                    ip: u.ip,
                                    habilitar: u.habilitar,
                                    precio: u.precio,
                                    bloqueo: u.bloqueo,
                                    uBloqueado: u.bloqueo === "1" ? true : false,
                                    ipHabilitada: u.habilitar === "1" ? true : false,
                                    vHabilitada: u.habilitar === "1" ? true : false
                                }
                            })
                        }
                        if (usuario.data.habilitar === "1") {
                            this.setState({
                                usuario: {
                                    ...this.state.usuario,
                                    ipHabilitada: true,
                                    vHabilitada: 1
                                }
                            })
                        }
                    }
                    else {
                        if (usuario.status === 404) {
                            localStorage.removeItem('ls');
                            window.location = window.location.origin;
                        }
                        else {
                            this.setState({
                                error: true,
                                message: usuario.message
                            })
                        }
                    }
                })
                .catch(err => {
                    this.setState({
                        error: true,
                        message: "Error de respuesta del servidor"
                    })
                })
        }
    }




    handleChange = (e) => {

        this.setState({
            usuario: {
                ...this.state.usuario,
                [e.target.name]: e.target.value
            }
        })

    }

    handleCheck = (e) => {
        if (this.state.usuario.ipHabilitada) {
            this.setState({
                usuario: {
                    ...this.state.usuario,
                    ipHabilitada: false,
                    habilitar: 0
                }
            })
        }
        else {
            this.setState({
                usuario: {
                    ...this.state.usuario,
                    ipHabilitada: true,
                    habilitar: 1
                }
            })
        }
    }

    handleBloqueoUsuario = (e) => {
        if (this.state.usuario.uBloqueado) {
            this.setState({
                usuario: {
                    ...this.state.usuario,
                    uBloqueado: false,
                    bloqueo: 0
                }
            })
        }
        else {
            this.setState({
                usuario: {
                    ...this.state.usuario,
                    uBloqueado: true,
                    bloqueo: 1
                }
            })
        }
    }

    dismiss() {
        this.setState({
            error: false,
            success: false,
            successe: false,
            message: ""
        })
    }



    render() {
        const { error, success, successe, message } = this.state;
        return (
            <Fragment>

                <form onSubmit={this.handleSubmit} autoComplete="off">
                    <div className="row">
                        <div className="col-md-6">
                            <label htmlFor="">Usuario</label>
                            <input type="text" name="usuario" id="usuario" className="form-control"
                                onChange={this.handleChange}
                                value={this.state.usuario.usuario || ""} />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="">Correo</label>
                            <input type="text" name="correo" id="correo" className="form-control"
                                onChange={this.handleChange}
                                value={this.state.usuario.correo || ""} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Nombre</label>
                                <input type="text" className="form-control" name="nombre" id="nombre" onChange={this.handleChange}
                                    value={this.state.usuario.nombre || ""} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Apellidos</label>
                                <input type="text" className="form-control" name="apellidos" id="apellidos" onChange={this.handleChange}
                                    value={this.state.usuario.apellidos || ""} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>IP</label>
                                <input type="text" className="form-control" name="ip" id="ip" onChange={this.handleChange}
                                    value={this.state.usuario.ip || ""} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Contraseña</label>
                                <input type="password" className="form-control" name="contrasena" id="contrasena" onChange={this.handleChange}
                                    value={this.state.usuario.contrasena || ""} />
                            </div>
                            {this.props.id && <small className="text-danger">Escribir la contraseña generará una nueva</small>}
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    {this.state.usuario.habilitar === "1" ?
                                        <input type="checkbox" className="custom-control-input mt-2" id="habilitar" name="habilitar" value={this.state.usuario.vHabilitada} onChange={this.handleCheck} defaultChecked={this.state.usuario.ipHabilitada} checked /> : <input type="checkbox" className="custom-control-input mt-2" id="habilitar" name="habilitar" value={this.state.usuario.vHabilitada} onChange={this.handleCheck} defaultChecked={this.state.usuario.ipHabilitada} />}
                                    <label className="custom-control-label" htmlFor="habilitar">Habilitar API</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Costo por mensaje</label>
                                <input type="number" className="form-control" name="precio" id="precio" onChange={this.handleChange}
                                    value={this.state.usuario.precio || ""} />
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12">

                            <div className="form-check form-check-inline">
                                {this.state.usuario.bloqueo === "1" ?
                                    <input className="form-check-input" type="checkbox" id="bloqueo" name="bloqueo" value={this.state.usuario.bloqueo} defaultChecked={this.state.usuario.uBloqueado} checked onChange={this.handleBloqueoUsuario} />
                                    :
                                    <input className="form-check-input" type="checkbox" id="bloqueo" name="bloqueo" value={this.state.usuario.bloqueo} defaultChecked={this.state.usuario.uBloqueado} onChange={this.handleBloqueoUsuario} />}
                                <label className="form-check-label" htmlFor="bloqueo">Bloquear usuario</label>
                            </div>
                        </div>
                    </div>
                    <div className="mt-3"></div>
                    <button className="btn btn-primary" type="submit" ref="btnGuardar">Guardar</button>
                    <Link className="ml-3 btn btn-danger" role="button" to="/lista-de-usuarios">Cancelar</Link>
                </form>
                {error ?
                    <div className="alert alert-danger alert-float">
                        <button type="button" class="close" onClick={() => this.dismiss()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <b>{message}</b>
                    </div> : null}
                {success ?
                    <div className="alert alert-success alert-float">
                        <button type="button" class="close" onClick={() => this.dismiss()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        Nuevo usuario creado
                    </div> : null}
                {successe ? <div className="alert alert-success alert-float">
                    <button type="button" class="close" onClick={() => this.dismiss()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    Datos cambiados
                </div> : null}
            </Fragment>
        );
    }
}

export default Formusers;


// WEBPACK FOOTER //
// ./src/components/users/Formusers.js